import Price from './price';
import {formatMoney, declension} from 'methods/utils';
import SplitPayButton from '/modules/hotels/src/js/components/order/split-pay-button';
import CancellationPolicyButton from '/modules/hotels/src/js/components/order/cancellation-policy/ui/button';

function Privettur(parent, search) {
    Price.call(this, parent, search);
}

Privettur.prototype = Object.create(Price.prototype);
Object.defineProperty(Privettur.prototype, 'constructor', {
    value: Privettur,
    enumerable: false,
    writable: true,
});

Privettur.prototype.hasPrice = function(apartment) {
    return !!apartment.min_price;
}

// номер для многономерных
Privettur.prototype.renderApartment = function($apartment, apartment) {
    const $item         = $apartment.querySelector('.js-plan');
    const $errorMessage = $apartment.querySelector('.js-roomPriceNotifcation');
    const $sendButton   = $apartment.querySelector('.js-buttonChange');
    const $title        = $apartment.querySelector('.js-title');
    const minPricePrefix = this.search.hasDates() ? '' : 'от ';
    const $cashbackBadge = $apartment.querySelector('.js-cashback-badge');
    const orderInfo = [];

    const split_pay = this.getSplitPayIfAvailable(apartment);
    const {booking} = apartment;

    if (split_pay) {
        orderInfo.push(SplitPayButton.make({ data: split_pay }));
    }

    if (booking) {
        orderInfo.push(CancellationPolicyButton.make({ booking }));
    }
    
    const cashbackRender = apartment.cashback ?
        `<span class="cashback js-cashback">
            <svg class="cashback__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="8" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28652 3.72147C6.58197 4.03412 6.56802 4.52707 6.25537 4.82252L5.219 5.80184L6.2668 6.83322C6.57336 7.13498 6.57725 7.62811 6.2755 7.93467C5.97374 8.24123 5.4806 8.24513 5.17404 7.94337L3.56283 6.3574C3.24178 6.04138 3.24706 5.52203 3.5745 5.21261L5.18547 3.69031C5.49813 3.39487 5.99108 3.40882 6.28652 3.72147Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.31009 5.82418C4.31365 5.39403 4.66524 5.04822 5.09538 5.05179L9.20043 5.08579C10.3128 5.07718 11.2024 5.47572 11.8075 6.14037C12.4008 6.79214 12.6684 7.64169 12.6667 8.45964C12.6634 10.0714 11.5663 11.8493 9.41213 11.8565C9.40773 11.8566 9.40306 11.8566 9.39814 11.8566H5.47889C5.04873 11.8566 4.70001 11.5079 4.70001 11.0778C4.70001 10.6476 5.04873 10.2989 5.47889 10.2989H9.38721C9.39115 10.2988 9.39532 10.2988 9.3997 10.2988C10.4776 10.2985 11.1069 9.45643 11.109 8.45643C11.11 7.967 10.949 7.51136 10.6556 7.18905C10.3752 6.88104 9.92228 6.63688 9.20776 6.64353L9.20091 6.64359L5.08248 6.60947C4.65233 6.60591 4.30652 6.25432 4.31009 5.82418ZM9.33396 10.3016C9.33381 10.3016 9.33368 10.3016 9.33356 10.3016L9.33376 10.3016C9.33382 10.3016 9.33389 10.3016 9.33396 10.3016Z" fill="white"/>
            </svg>
            <span class="cashback__value">
                ${declension(apartment.cashback, 'Начислим %d бонус', 'Начислим %d бонуса', 'Начислим %d бонусов').replace('%d', apartment.cashback)}
            </span>
        </span>` : '';

    $item.innerHTML = (
        `<div class="item-wrapper">
            ${apartment.old_price ?
                `<div class="hot-price">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                        <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                    </svg>
                    <span>${minPricePrefix}${formatMoney(apartment.min_price)} ₽</span>
                </div>
                <div class="old-price">${minPricePrefix}${formatMoney(apartment.old_price)} ₽</div>` : `<div class="main-price">${minPricePrefix}${formatMoney(apartment.min_price)} ₽</div>`
            }
        </div>
        <p class="description">${apartment.price_variant_title}</p>
        ${cashbackRender}`
    );

    const $orderInfo = $apartment.querySelector('.js-order-info');
    if ($orderInfo) {
        $orderInfo.replaceChildren(...orderInfo.map((button) => button.getElement()));
    }

    $apartment.classList.remove('has-error');
    $errorMessage.textContent = '';

    if (apartment.error) {
        $errorMessage.textContent = apartment.error;
        $apartment.classList.add('has-error');
    }

    // хотфикс, тарифы рендерятся с бэка, рендерятся неправильно, нет доступа к тарифам из класса родителя
    // поэтому приходится удалять так
    $apartment.querySelectorAll('.plan-item').forEach($item => {
        $item.classList.toggle('is-hidden', $apartment.classList.contains('has-error'));
    });

    if ($sendButton && apartment.min_price) {
        $sendButton.dataset.apartment_id    = apartment.id;
        $sendButton.dataset.apartment_title = apartment.title;
        $sendButton.dataset.price           = apartment.min_price;
        $sendButton.setAttribute('onmouseup', `jsLink('${apartment.order_url}', '_blank', false, window.sendOrderMetrics(2, this));`);
    }

    $title.textContent = apartment.title;

    if (!apartment.error && apartment.suitable_room_count > 1) {
        $title.textContent = `${apartment.suitable_room_count} × ${apartment.title}`;
    }

    if ($cashbackBadge) {
        $cashbackBadge.textContent = declension(apartment.cashback, 'Кэшбэк %d бонус', 'Кэшбэк %d бонуса', 'Кэшбэк %d бонусов').replace('%d', apartment.cashback);
        $cashbackBadge.toggleAttribute('hidden', !apartment.cashback);
    }
}

// без номеров
Privettur.prototype.renderSingleApartment = function(apartment) {
    const $totalAmount = document.querySelector('.js-totalAmount');
    const $totalAmountWrapper = document.querySelector('.js-totalAmountWrapper');
    const $totalError = $totalAmount.querySelector('.js-totalError');
    const $sendButton = document.querySelector('.js-contactWrapper .js-buttonChange');
    const $writeOwnerCashback = document.querySelector('.js-writeOwnerCashback');

    if ($writeOwnerCashback) {
        $writeOwnerCashback.classList.toggle('is-active', false);
    }

    // показываем цены и ошибки
    $totalAmount.classList.add('is-active');

    if (window.hotelPortal) {
        const portal = window.hotelPortal;

        if (!this.search.hasDates()) {
            portal.reset(apartment.min_price);
        } else {
            const options = {day: 'numeric', month: 'short'};
            const dateArrival = new Date(this.search.getData().date_start).toLocaleString('ru-Ru', options);
            const dateDeparture = new Date(this.search.getData().date_finish).toLocaleString('ru-Ru', options);
            const requestUrl = document.querySelector('.js-mainNav').getAttribute('data-order_url');

            portal.setDates(dateArrival, dateDeparture);
            portal.setText(apartment.price_variant_title);
            portal.setValue(apartment.min_price);
            portal.setButtonData('Оставить заявку', requestUrl);
        }
    }

    $totalAmount.classList.remove('has-error');
    if (apartment.error) {
        $totalError.innerHTML = apartment.error;
        $totalAmount.classList.add('has-error');

        return;
    }

    const lines = [];
    const nights = this.search.daysCount() || 1;
    const perNight = apartment.min_price / nights;
    const hasDates = this.search.hasDates();
    const orderInfo = [];

    const split_pay = this.getSplitPayIfAvailable(apartment);
    const {booking} = apartment;

    if (split_pay) {
        orderInfo.push(SplitPayButton.make({ data: split_pay }));
    }

    if (booking) {
        orderInfo.push(CancellationPolicyButton.make({ booking }));
    }

    if (isFinite(perNight)) {
        const pricePrefix = !hasDates ? 'от ' : '';

        lines.push(
            `<div class="Write-owner__total-row">
                <div>За сутки</div>
                <div>
                    ${apartment.old_price ?
                        `<div class="hot-price">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                            </svg>
                            <span>${pricePrefix}${formatMoney(apartment.min_price / nights)} ₽</span>
                        </div>
                        <div class="old-price">
                            ${pricePrefix}${formatMoney(apartment.old_price / nights)} ₽
                        </div>` : `<span class="main-price main-price_mini">${pricePrefix}${formatMoney(apartment.min_price / nights)} ₽</span>`
                    }
                </div>
            </div>`
        );
    }

    if (hasDates && nights > 1) {
        lines.push(
            `<div class="Write-owner__total-row">
                <div>${apartment.price_variant_title}</div>
                <div>
                    ${apartment.old_price ?
                        `<div class="hot-price">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                            </svg>
                            <span>${formatMoney(apartment.min_price)} ₽</span>
                        </div>
                        <div class="old-price">
                            ${formatMoney(apartment.old_price)} ₽
                        </div>` : `<span class="main-price main-price_mini">${formatMoney(apartment.min_price)} ₽</span>`
                    }
                </div>
            </div>`
        );
    }

    if (apartment.cashback) {
        lines.push(
            `<div class="Write-owner__total-discount">
                <span class="cashback js-cashback">
                    <svg class="cashback__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="currentColor"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28652 3.72147C6.58197 4.03412 6.56802 4.52707 6.25537 4.82252L5.219 5.80184L6.2668 6.83322C6.57336 7.13498 6.57725 7.62811 6.2755 7.93467C5.97374 8.24123 5.4806 8.24513 5.17404 7.94337L3.56283 6.3574C3.24178 6.04138 3.24706 5.52203 3.5745 5.21261L5.18547 3.69031C5.49813 3.39487 5.99108 3.40882 6.28652 3.72147Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.31009 5.82418C4.31365 5.39403 4.66524 5.04822 5.09538 5.05179L9.20043 5.08579C10.3128 5.07718 11.2024 5.47572 11.8075 6.14037C12.4008 6.79214 12.6684 7.64169 12.6667 8.45964C12.6634 10.0714 11.5663 11.8493 9.41213 11.8565C9.40773 11.8566 9.40306 11.8566 9.39814 11.8566H5.47889C5.04873 11.8566 4.70001 11.5079 4.70001 11.0778C4.70001 10.6476 5.04873 10.2989 5.47889 10.2989H9.38721C9.39115 10.2988 9.39532 10.2988 9.3997 10.2988C10.4776 10.2985 11.1069 9.45643 11.109 8.45643C11.11 7.967 10.949 7.51136 10.6556 7.18905C10.3752 6.88104 9.92228 6.63688 9.20776 6.64353L9.20091 6.64359L5.08248 6.60947C4.65233 6.60591 4.30652 6.25432 4.31009 5.82418ZM9.33396 10.3016C9.33381 10.3016 9.33368 10.3016 9.33356 10.3016L9.33376 10.3016C9.33382 10.3016 9.33389 10.3016 9.33396 10.3016Z" fill="white"/>
                    </svg>
                    <span class="cashback__value">
                        ${declension(apartment.cashback, 'Начислим %d бонус', 'Начислим %d бонуса', 'Начислим %d бонусов').replace('%d', apartment.cashback)}
                    </span>
                </span>
            </div>`
        );
    }

    if (orderInfo.length) {
        lines.push(`<div class="Write-owner__total-row Write-owner__order-info js-order-info"></div>`);
    }

    $totalAmountWrapper.innerHTML = (
        `<div class="Write-owner__total-title">Итоговая сумма:</div>${lines.join("\n")}`
    );

    const $orderInfo = $totalAmountWrapper.querySelector('.js-order-info');
    if ($orderInfo) {
        $orderInfo.append(...orderInfo.map((button) => button.getElement()));
    }

    if ($sendButton && apartment.min_price) {
        $sendButton.dataset.apartment_id    = apartment.id;
        $sendButton.dataset.apartment_title = apartment.title;
        $sendButton.dataset.price           = apartment.min_price;
    }
}

export default Privettur;
